'use strict';

const decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');



// WEBPACK FOOTER //
// ./node_modules/browserify-sign/node_modules/asn1.js/lib/asn1/decoders/index.js